/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!  WARNING: Do NOT edit this file!  !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * Foundation components are not intended to be edited to
 * satisfy specific use cases. If this component does not
 * do what you need it to, please reach out to a frontend
 * engineer before creating a new component or making
 * unapproved changes to this file.
 *
 * @author Nathan Buchar <nathan.buchar@hellosign.com>
 */

import React from 'react';
import classnames from 'classnames';

import { IconButton, IconButtonProps } from 'dig-components/buttons';
import { TextInput, TextInputProps, TextInputRefObject } from 'dig-components/dist/text_fields';
import { UIIcon } from 'dig-components/icons';
import { SearchLine } from 'dig-components/icons/src';
import styles from './search-bar.scss';

export type SearchBarPropTypes = React.BaseHTMLAttributes<HTMLFormElement>;

export function SearchBar({
  onBlur,
  onFocus,
  children,
  className = '',

  // All other props will be applied to root div element
  ...props
}: SearchBarPropTypes) {
  return (
    <form
      data-qa-ref="search-bar"
      className={classnames(styles.searchBar, className)}
      {...props}
    >
      {children}
    </form>
  );
}

export type SearchBarFieldPropTypes = TextInputProps & {
  value?: string,
  autoComplete?: 'off' | 'on',
  disabled?: boolean,
  maxlength?: number,
};

function SearchBarField({
  className = '',
  ...props
}: SearchBarFieldPropTypes, ref: React.Ref<TextInputRefObject>) {
  return (
    <TextInput
      wrapperProps={{
        className: styles.searchBarFieldWrapper,
      }}
      ref={ref}
      name="q" // Q the liar! Q the misanthrope!
      data-qa-ref="search-bar-field"
      placeholder="Enter a keyword"
      className={classnames(styles.searchBarField, className)}
      withLeftAccessory={<UIIcon src={SearchLine} className={styles.searchBarSearchIcon} />}
      {...props} />
  );
}

export type SearchBarSubmitPropTypes = Omit<IconButtonProps, 'variant'>;

function SearchBarSubmit({
  className = '',
  ...props
}: SearchBarSubmitPropTypes) {
  return (
    <IconButton
      type="submit"
      data-qa-ref="search-bar-submit"
      variant="transparent"
      {...props}
      className={classnames(styles.searchBarSubmit, className)}
    >
      <UIIcon src={SearchLine} />
    </IconButton>
  );
}

SearchBar.Field = React.forwardRef(SearchBarField);
SearchBar.Submit = SearchBarSubmit;
